import { ChangeDetectorRef, Component, OnInit, HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateFilterFn } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppPages } from '@constants/app-pages';
import { GetConfiguracoesInternacionalizacaoRepository } from '@data/repository/home/getConfiguracoesInternacionalizacao.repository';
import { GetParametrosLocacaoRepository } from '@data/repository/home/getParametrosLocacao.respository';
import { Cidade, Feriado, Unidade } from '@domain/dto/cidade/cidade-get.dto';
import { Cupom, CupomEntity } from '@domain/dto/reserva/reserva-cupom-get.dto';
import { environment } from '@environment/environment';
import { ReservaService } from '@infra/reserva/reserva.service';
import { I18nService } from '@infra/translations/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiSecundariaController } from '@presentation/controllers/api-secundaria-controller/api-secundaria.controller';
import { HomeController } from '@presentation/controllers/home/home.controller';
import { ReservaController } from '@presentation/controllers/reserva/reserva.controller';
import { BaseComponent } from '@presentation/view/base/base.component';
import { DialogRetrieveDataComponent } from '@presentation/view/shared/dialogs/dialog-retrieve-data/dialog-retrieve-data.component';
import {
  NotificationService,
  NotificationStyle,
} from '@presentation/view/shared/notification/notification.service';
import { HoraFormatadaPipe } from '@presentation/view/shared/pipes/horaFormatada.pipe';
import * as moment from 'moment';
import { BehaviorSubject, Observable, finalize, interval, map, startWith } from 'rxjs';
import { DateUtil } from 'src/app/shared/utils/date.util';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  isLoading: boolean = false;
  isSamePlaceDeliverDisabled: boolean = false;
  isDataFromApi: boolean = false;
  showSecondRowBool: boolean = true;
  deliverAtSamePlaceBool: boolean = false;
  requestError: boolean = false;
  unidades: Unidade[] = [];
  firstMinDateDevolucao!: Date;
  secondMinDateDevolucao!: Date;
  firstSelectedCity!: Unidade;
  secondSelectedCity!: Unidade;
  logo$$ = new BehaviorSubject<string>('');
  firstDateSelected!: string;
  secondDateSelected!: string;
  firstDateDefault!: Date;
  secondDateDefault!: Date;
  firstHourSelected!: string;
  secondHourSelected!: string;
  firstHoraInicioFuncionamento!: string;
  firstHoraFinalFuncionamento!: string;
  secondHoraInicioFuncionamento!: string;
  secondHoraFinalFuncionamento!: string;
  PercentDiscount!: number;
  DiscountCouponCode!: number;
  myControlRetirada = new FormControl('');
  myControlDevolucao = new FormControl('');
  myControlCupom = new FormControl('');
  filteredOptions!: Observable<Unidade[]>;
  filteredOptions2!: Observable<Unidade[]>;
  autoCompleteByQuery = this.router.parseUrl(this.router.url).queryParams;
  cupom?: Cupom | null;
  weekDays = ['Domingo', 'Segunda', 'Terca', 'Quarta', 'Quinta', 'Sexta', 'Sabado'];
  darkTheme = {
    container: {
      buttonColor: sessionStorage.getItem('primaryColor') || '#000000',
    },
    dial: {
      dialBackgroundColor: sessionStorage.getItem('primaryColor') || '#000000',
    },
    clockFace: {
      clockHandColor: sessionStorage.getItem('primaryColor') || '#000000',
    },
  };
  currentLanguage;
  firstDateOpen = false;
  isMediumWidth: boolean = false;

  years = [2023, 2024, 2025, 2026];
  actualYear = new Date().getFullYear();

  minutesGap = (localStorage.getItem('codigoIdentificador') || '0') == '788' ? 30 : 5;
  municipios: Cidade[] = [];
  defaultLanguage: string = environment.defaultLanguage;

  firstDiaFechadoPorFeriado: boolean = false;
  secondDiaFechadoPorFeriado: boolean = false;

  firstDiaNomeFeriado: string = '';
  secondDiaNomeFeriado: string = '';

  constructor(
    private baseComponent: BaseComponent,
    private controller: HomeController,
    private apiSecundariaController: ApiSecundariaController,
    private router: Router,
    private reservaService: ReservaService,
    private i18nService: I18nService,
    private notification: NotificationService,
    private dialog: MatDialog,
    public translateService: TranslateService,
    private controllerReserva: ReservaController,
    private getConfiguracoesInternacionalizacaoRepository: GetConfiguracoesInternacionalizacaoRepository,
    private getParametrosLocacaoRepository: GetParametrosLocacaoRepository,
    private horaFormatadaPipe: HoraFormatadaPipe
  ) {
    this.baseComponent.showToolbar = false;
    this.currentLanguage = localStorage.getItem('language')
  }

  async ngOnInit() {
    this.onResize();
    this.logo$$.next(sessionStorage.getItem('urlLogo') || '');
    await this.getCities();
    if (history.state.useDataFromStorage) await this.patchDataFromStorage();
    else this.reservaService?.homeData ? await this.openRetrieveDataDialog() : null;
    this.secondMinDateDevolucao = new Date();
    this.scrollTop();
    interval(100).subscribe(() => this.logo$$.next(sessionStorage.getItem('urlLogo') || ''));
    this.getConfiguracoesInternacionalizacao()
  }

  async openRetrieveDataDialog() {
    const dialogRef = this.dialog.open(DialogRetrieveDataComponent);
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result == true) await this.patchDataFromStorage();
      else if (result == false) this.reservaService.clear();
    });
  }

  async patchDataFromStorage() {
    if (this.reservaService.homeData) {
      this.firstSelectedCity = this.reservaService.homeData.firstSelectedCity;
      this.secondSelectedCity = this.reservaService.homeData.secondSelectedCity;
      this.firstDateSelected = this.reservaService.homeData.firstDateSelected;
      this.secondDateSelected = this.reservaService.homeData.secondDateSelected;
      this.firstHourSelected = this.reservaService.homeData.firstHourSelected;
      this.secondHourSelected = this.reservaService.homeData.secondHourSelected;

      this.myControlRetirada.setValue(
        this.reservaService.homeData.firstSelectedCity.DescricaoUnidade
      );
      this.myControlDevolucao.setValue(
        this.reservaService.homeData.secondSelectedCity.DescricaoUnidade
      );

      // Ajusta as datas para o formato correto
      const adjustDateFormat = (date: string) => {
        if (environment.defaultDateInput === 'MM/DD/YYYY') {
          const [month, day, year] = date.split('/');
          return `${day}/${month}/${year}`; // Converte para DD/MM/YYYY
        }
        return date; // Mantém DD/MM/YYYY
      };

      this.firstDateSelected = adjustDateFormat(this.firstDateSelected);
      this.secondDateSelected = adjustDateFormat(this.secondDateSelected);

      this.firstDateDefault = new Date(DateUtil.changeDDMMtoMMDD(this.firstDateSelected));
      this.secondDateDefault = new Date(DateUtil.changeDDMMtoMMDD(this.secondDateSelected));
      this.firstMinDateDevolucao = new Date(DateUtil.changeDDMMtoMMDD(this.firstDateSelected));

      this.cupom = this.reservaService.cupomData;
      this.myControlCupom.setValue(this.cupom?.Descricao);

      this.setFirstDayOpeningHours();
      this.setSecondDayOpeningHours();

      if (this.firstSelectedCity?.CodigoMunicipio == this.secondSelectedCity?.CodigoMunicipio) {
        this.deliverAtSamePlaceBool = true;
      }

      this.isDataFromApi = true;
      this.verifyDeliverAtSamePlace();
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.isMediumWidth = window.innerWidth >= 1020 && window.innerWidth <= 1500;
  }

  async getCities() {
    this.isLoading = true;
    this.controller
      .get()
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.buildMatAutoCompleteRetirada();
          this.buildMatAutoCompleteDevolucao();
        })
      )
      .subscribe((municipio: any) => {
        this.municipios.push(municipio);

        municipio.Unidades.forEach((unidade: any) => {
          this.unidades.push(unidade);
        });
        this.completeFields();
      });
  }



  completeFields() {
    if (this.autoCompleteByQuery['cidadeRetirada']) {
      const findFirstCity = this.municipios.find(
        (city) => city.CodigoMunicipio == this.autoCompleteByQuery['cidadeRetirada']
      );

      const findSecondCity = this.municipios.find(
        (city) => city.CodigoMunicipio == this.autoCompleteByQuery['cidadeDevolucao']
      );

      const findFirstUnity =
        this.unidades.find(
          (unity) =>
            unity.CodigoMunicipio == this.autoCompleteByQuery['cidadeRetirada'] &&
            unity.CodigoUnidade == this.autoCompleteByQuery['unidadeRetirada']
        ) ??
        findFirstCity?.Unidades.find(
          (unity) => unity.CodigoUnidade == this.autoCompleteByQuery['unidadeRetirada']
        );

      const findSecondUnity =
        this.unidades.find(
          (unity) =>
            unity.CodigoMunicipio == this.autoCompleteByQuery['cidadeDevolucao'] &&
            unity.CodigoUnidade == this.autoCompleteByQuery['unidadeDevolucao']
        ) ??
        findSecondCity?.Unidades.find(
          (unity) => unity.CodigoUnidade == this.autoCompleteByQuery['unidadeDevolucao']
        );

      if (findFirstUnity && findSecondUnity) {
        this.firstSelectedCity = findFirstUnity;
        this.secondSelectedCity = findSecondUnity;
        this.firstDateSelected = this.autoCompleteByQuery['dataRetirada'];
        this.secondDateSelected = this.autoCompleteByQuery['dataDevolucao'];
        this.firstHourSelected = this.autoCompleteByQuery['horarioRetirada']?.padStart(5, '0');
        this.secondHourSelected = this.autoCompleteByQuery['horarioDevolucao']?.padStart(5, '0');
        this.firstSelectCityEvent(findFirstUnity);
        this.secondSelectCityEvent(findSecondUnity);
        this.firstDateDefault = new Date(
          DateUtil.changeDDMMtoMMDD(this.autoCompleteByQuery['dataRetirada'])
        );
        this.secondDateDefault = new Date(
          DateUtil.changeDDMMtoMMDD(this.autoCompleteByQuery['dataDevolucao'])
        );
        this.firstMinDateDevolucao = new Date(
          DateUtil.changeDDMMtoMMDD(this.autoCompleteByQuery['dataRetirada'])
        );
        this.setFirstDayOpeningHours();
        this.setSecondDayOpeningHours();
        this.setFirstHour(this.autoCompleteByQuery['horarioRetirada']);
        this.setSecondHour(this.autoCompleteByQuery['horarioDevolucao']);
        if (this.firstSelectedCity?.CodigoMunicipio == this.secondSelectedCity?.CodigoMunicipio) {
          this.deliverAtSamePlaceBool = true;
        }
      }

      this.isDataFromApi = true;
      this.verifyDeliverAtSamePlace();
    }
  }

  buildMatAutoCompleteRetirada() {
    this.filteredOptions = this.myControlRetirada.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || ''))
    );
  }

  buildMatAutoCompleteDevolucao() {
    this.filteredOptions2 = this.myControlDevolucao.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || ''))
    );
  }

  private _filter(value: string): Unidade[] {
    const filterValue = value?.length > 0 ? value?.toLowerCase() : '';
    return this.unidades.filter((unidade: Unidade) =>
      unidade?.DescricaoUnidade?.toLowerCase()?.includes(filterValue)
    );
  }

  showSecondRow() {
    if (this.validateFirstRow()) this.showSecondRowBool = true;
  }

  validateFirstRow() {
    return (
      this.firstHourSelected?.length > 0 &&
      this.myControlRetirada.value?.length > 0 &&
      this.firstDateSelected?.length > 0
    );
  }

  validateSecondThirdRow() {
    return (
      this.secondHourSelected?.length > 0 &&
      this.myControlDevolucao.value?.length > 0 &&
      this.secondDateSelected?.length > 0
    );
  }

  removeColon(hour): string {
    return hour?.replace(':', '') ?? '';
  }

  validHoursAndDates() {
    let validHourAndDate = true;

    const addColonToHour = (hour: string) => {
      if (!hour || hour.length !== 4 || isNaN(+hour)) return hour; // retorna como está se for inválido
      return `${hour.slice(0, 2)}:${hour.slice(2, 4)}`;
    };


    if (this.firstSelectedCity && this.firstDateSelected && this.firstHourSelected) {
      let isSunday = false;
      let isSaturday = false;
      let isHoliday = false;
      let isSegSex = false;
      if (this.firstDateSelected) {
        const [day, month, year] = this.firstDateSelected.split('/');
        const date = environment.defaultDateInput == "MM/DD/YYYY" ? [year, day, month]?.join('-') : [year, month, day]?.join('-');
        const dayOfWeek = moment(date).day();
        if (dayOfWeek == 0) isSunday = true;
        if (dayOfWeek == 6) isSaturday = true;
        if (dayOfWeek > 0 && dayOfWeek < 6) isSegSex = true;
        this.firstSelectedCity?.Feriados.forEach((feriado: Feriado) => {
          if (feriado.Ano) {
            if (feriado.Ano == +year && feriado.Dia == +day && feriado.Mes == +month) {
              isHoliday = true;
            }
          } else {
            if (feriado.Dia == +day && feriado.Mes == +month) {
              isHoliday = true;
            }
          }
        });
      }

      const citySundayHourOpen = +this.firstSelectedCity?.HoraInicioFuncionamentoDomingo?.replace(
        ':',
        ''
      );
      const citySaturdayHourOpen = +this.firstSelectedCity?.HoraInicioFuncionamentoSabado?.replace(
        ':',
        ''
      );
      const citySundayHourClose = +this.firstSelectedCity?.HoraTerminoFuncionamentoDomingo?.replace(
        ':',
        ''
      );
      const citySaturdayHourClose =
        +this.firstSelectedCity?.HoraTerminoFuncionamentoSabado?.replace(':', '');
      const selectedFirstHour = +this.firstHourSelected.replace(':', '');
      const citySegSexHourOpen = +this.firstSelectedCity?.HoraInicioFuncionamentoSegSex?.replace(
        ':',
        ''
      );
      const citySegSexHourClose = +this.firstSelectedCity?.HoraTerminoFuncionamentoSegSex?.replace(
        ':',
        ''
      );



      if (isHoliday) {
        const findFeriado = this.firstSelectedCity?.Feriados.find(
          (i: Feriado) =>
            i.Dia === +this.firstDateSelected?.split('/')[0] &&
            i.Mes === +this.firstDateSelected?.split('/')[1]
        );

        const horaSelecionada = +this.removeColon(selectedFirstHour?.toString() ?? '');

        if (findFeriado?.HoraInicio && findFeriado?.HoraFim) {
          const horaFeriadoInicio = +this.removeColon(findFeriado.HoraInicio);
          const horaFeriadoFim = +this.removeColon(findFeriado.HoraFim);

          const feriadoTemHorario = !(horaFeriadoInicio === 0 && horaFeriadoFim === 1);

          if (feriadoTemHorario) {
            const foraDoHorario = horaSelecionada < horaFeriadoInicio || horaSelecionada > horaFeriadoFim;

            if (foraDoHorario) {
              this.notification.showError(
                this.translateService.instant('MSG_PICKUP_UNIT_HOLIDAY_HOURS', {
                  unit: this.firstSelectedCity.DescricaoUnidade,
                  holiday: findFeriado.Descricao,
                  startHour: this.horaFormatadaPipe.transform(addColonToHour(findFeriado.HoraInicio)),
                  endHour: this.horaFormatadaPipe.transform(addColonToHour(findFeriado.HoraFim)),
                })
              );
              validHourAndDate = false;
            }
          } else {
            // Feriado sem horário definido (padrão 0000–0001)
            this.notification.showError(
              this.translateService.instant('MSG_PICKUP_UNIT_HOLIDAY', {
                unit: this.firstSelectedCity.DescricaoUnidade,
              })
            );
            validHourAndDate = false;
          }
        } else {
          // Feriado sem horário preenchido
          this.notification.showError(
            this.translateService.instant('MSG_PICKUP_UNIT_HOLIDAY', {
              unit: this.firstSelectedCity.DescricaoUnidade,
            })
          );
          validHourAndDate = false;
        }
      }


      if (isSunday && (isNaN(citySundayHourOpen) || isNaN(citySundayHourClose))) {
        this.notification.showError(
          this.translateService.instant('MSG_PICKUP_UNIT_SUNDAY', {
            unit: this.firstSelectedCity.DescricaoUnidade,
          })
        );
        validHourAndDate = false;
      } else if (isSunday && citySundayHourOpen && citySundayHourClose) {
        if (citySundayHourOpen > +selectedFirstHour || citySundayHourClose < +selectedFirstHour) {
          this.notification.showError(
            this.translateService.instant('MSG_PICKUP_UNIT_SUNDAY_HOURS', {
              unit: this.firstSelectedCity.DescricaoUnidade,
              startHour: this.horaFormatadaPipe.transform(addColonToHour(this.firstSelectedCity?.HoraInicioFuncionamentoDomingo)),
              endHour: this.horaFormatadaPipe.transform(addColonToHour(this.firstSelectedCity?.HoraTerminoFuncionamentoDomingo)),
            })
          );
          validHourAndDate = false;
        }
      }

      if (isSaturday && (isNaN(citySaturdayHourOpen) || isNaN(citySaturdayHourClose))) {
        this.notification.showError(
          this.translateService.instant('MSG_PICKUP_UNIT_SATURDAY', {
            unit: this.firstSelectedCity.DescricaoUnidade,
          })
        );
        validHourAndDate = false;
      } else if (isSaturday && citySaturdayHourOpen && citySaturdayHourClose) {
        if (
          citySaturdayHourOpen > +selectedFirstHour ||
          citySaturdayHourClose < +selectedFirstHour
        ) {
          this.notification.showError(
            this.translateService.instant('MSG_PICKUP_UNIT_SATURDAY_HOURS', {
              unit: this.firstSelectedCity.DescricaoUnidade,
              startHour: this.horaFormatadaPipe.transform(addColonToHour(this.firstSelectedCity?.HoraInicioFuncionamentoSabado)),
              endHour: this.horaFormatadaPipe.transform(addColonToHour(this.firstSelectedCity?.HoraTerminoFuncionamentoSabado)),
            })
          );
          validHourAndDate = false;
        }
      }

      if (isSegSex && citySegSexHourOpen && citySegSexHourClose) {
        if (citySegSexHourOpen > +selectedFirstHour || citySegSexHourClose < +selectedFirstHour) {
          this.notification.showError(
            this.translateService.instant('MSG_PICKUP_UNIT_WEEKDAYS_HOURS', {
              unit: this.firstSelectedCity.DescricaoUnidade,
              startHour: this.horaFormatadaPipe.transform(addColonToHour(this.firstSelectedCity?.HoraInicioFuncionamentoSegSex)),
              endHour: this.horaFormatadaPipe.transform(addColonToHour(this.firstSelectedCity?.HoraTerminoFuncionamentoSegSex)),
            })
          );
          validHourAndDate = false;
        }
      }
    }

    if (this.secondSelectedCity && this.secondDateSelected && this.secondHourSelected) {
      let isSunday = false;
      let isSaturday = false;
      let isHoliday = false;
      let isSegSex = false;
      if (this.secondDateSelected) {
        const [day, month, year] = this.secondDateSelected.split('/');
        const date = [year, month, day]?.join('-');
        const dayOfWeek = moment(date).day();
        if (dayOfWeek == 0) isSunday = true;
        if (dayOfWeek == 6) isSaturday = true;
        if (dayOfWeek > 0 && dayOfWeek < 6) isSegSex = true;
        this.secondSelectedCity?.Feriados.forEach((feriado: Feriado) => {
          if (feriado.Ano) {
            if (feriado.Ano == +year && feriado.Dia == +day && feriado.Mes == +month) {
              isHoliday = true;
            }
          } else {
            if (feriado.Dia == +day && feriado.Mes == +month) {
              isHoliday = true;
            }
          }
        });
      }

      const citySundayHourOpen = +this.secondSelectedCity?.HoraInicioFuncionamentoDomingo?.replace(
        ':',
        ''
      );
      const citySaturdayHourOpen = +this.secondSelectedCity?.HoraInicioFuncionamentoSabado?.replace(
        ':',
        ''
      );
      const citySundayHourClose =
        +this.secondSelectedCity?.HoraTerminoFuncionamentoDomingo?.replace(':', '');
      const citySaturdayHourClose =
        +this.secondSelectedCity?.HoraTerminoFuncionamentoSabado?.replace(':', '');
      const selectedSecondHour = +this.secondHourSelected.replace(':', '');
      const citySegSexHourOpen = +this.secondSelectedCity?.HoraInicioFuncionamentoSegSex?.replace(
        ':',
        ''
      );
      const citySegSexHourClose = +this.secondSelectedCity?.HoraTerminoFuncionamentoSegSex?.replace(
        ':',
        ''
      );

      if (isHoliday) {
        const findFeriado = this.secondSelectedCity?.Feriados.find(
          (i: Feriado) =>
            i.Dia === +this.secondDateSelected?.split('/')[0] &&
            i.Mes === +this.secondDateSelected?.split('/')[1]
        );

        const horaSelecionada = +this.removeColon(selectedSecondHour?.toString() ?? '');

        if (findFeriado?.HoraInicio && findFeriado?.HoraFim) {
          const horaFeriadoInicio = +this.removeColon(findFeriado.HoraInicio);
          const horaFeriadoFim = +this.removeColon(findFeriado.HoraFim);

          const feriadoTemHorario = !(horaFeriadoInicio === 0 && horaFeriadoFim === 1);

          if (feriadoTemHorario) {
            const foraDoHorario = horaSelecionada < horaFeriadoInicio || horaSelecionada > horaFeriadoFim;

            if (foraDoHorario) {
              this.notification.showError(
                this.translateService.instant('MSG_RETURN_UNIT_HOLIDAY_HOURS', {
                  unit: this.secondSelectedCity.DescricaoUnidade,
                  holiday: findFeriado.Descricao,
                  startHour: this.horaFormatadaPipe.transform(addColonToHour(findFeriado.HoraInicio)),
                  endHour: this.horaFormatadaPipe.transform(addColonToHour(findFeriado.HoraFim)),
                })
              );
              validHourAndDate = false;
            }
          } else {
            this.notification.showError(
              this.translateService.instant('MSG_RETURN_UNIT_HOLIDAY', {
                unit: this.secondSelectedCity.DescricaoUnidade,
              })
            );
            validHourAndDate = false;
          }
        } else {
          this.notification.showError(
            this.translateService.instant('MSG_RETURN_UNIT_HOLIDAY', {
              unit: this.secondSelectedCity.DescricaoUnidade,
            })
          );
          validHourAndDate = false;
        }
      }
      if (isSunday && (!citySundayHourOpen || !citySundayHourClose)) {
        this.notification.showError(
          this.translateService.instant('MSG_RETURN_UNIT_SUNDAY', {
            unit: this.secondSelectedCity.DescricaoUnidade,
          })
        );
        validHourAndDate = false;
      } else if (isSunday && citySundayHourOpen && citySundayHourClose) {
        if (citySundayHourOpen > +selectedSecondHour || citySundayHourClose < +selectedSecondHour) {
          this.notification.showError(
            this.translateService.instant('MSG_RETURN_UNIT_SUNDAY_HOURS', {
              unit: this.secondSelectedCity.DescricaoUnidade,
              startHour: this.horaFormatadaPipe.transform(addColonToHour(this.secondSelectedCity?.HoraInicioFuncionamentoDomingo)),
              endHour: this.horaFormatadaPipe.transform(addColonToHour(this.secondSelectedCity?.HoraTerminoFuncionamentoDomingo)),
            })
          );
          validHourAndDate = false;
        }
      }

      if (isSaturday && (!citySaturdayHourOpen || !citySaturdayHourClose)) {
        this.notification.showError(
          this.translateService.instant('MSG_RETURN_UNIT_SATURDAY', {
            unit: this.secondSelectedCity.DescricaoUnidade,
          })
        );
        validHourAndDate = false;
      } else if (isSaturday && citySaturdayHourOpen && citySaturdayHourClose) {
        if (
          citySaturdayHourOpen > +selectedSecondHour ||
          citySaturdayHourClose < +selectedSecondHour
        ) {
          this.notification.showError(
            this.translateService.instant('MSG_RETURN_UNIT_SATURDAY_HOURS', {
              unit: this.secondSelectedCity.DescricaoUnidade,
              startHour: this.horaFormatadaPipe.transform(addColonToHour(this.secondSelectedCity?.HoraInicioFuncionamentoSabado)),
              endHour: this.horaFormatadaPipe.transform(addColonToHour(this.secondSelectedCity?.HoraTerminoFuncionamentoSabado)),
            })
          );
          validHourAndDate = false;
        }
      }

      if (isSegSex && citySegSexHourOpen && citySegSexHourClose) {
        if (citySegSexHourOpen > +selectedSecondHour || citySegSexHourClose < +selectedSecondHour) {
          this.notification.showError(
            this.translateService.instant('MSG_RETURN_UNIT_WEEKDAYS_HOURS', {
              unit: this.secondSelectedCity.DescricaoUnidade,
              startHour: this.horaFormatadaPipe.transform(addColonToHour(this.secondSelectedCity?.HoraInicioFuncionamentoSegSex)),
              endHour: this.horaFormatadaPipe.transform(addColonToHour(this.secondSelectedCity?.HoraTerminoFuncionamentoSegSex)),
            })
          );
          validHourAndDate = false;
        }
      }
    }
    return validHourAndDate;
  }

  validateFields() {
    this.myControlRetirada.markAsTouched();
    this.myControlDevolucao.markAllAsTouched();

    if (!this.firstSelectedCity) {
      this.notification.showSnack(
        this.translateService.instant('MSG_SELECT_PICKUP_UNIT'),
        NotificationStyle.ERROR
      );
      return false;
    }
    if (!this.secondSelectedCity) {
      this.notification.showSnack(
        this.translateService.instant('MSG_SELECT_RETURN_UNIT'),
        NotificationStyle.ERROR
      );
      return false;
    }
    if (!this.firstDateSelected) {
      this.notification.showSnack(
        this.translateService.instant('MSG_INSERT_PICKUP_DATE'),
        NotificationStyle.ERROR
      );
      return false;
    }
    if (!this.secondDateSelected) {
      this.notification.showSnack(
        this.translateService.instant('MSG_INSERT_RETURN_DATE'),
        NotificationStyle.ERROR
      );
      return false;
    }
    if (!this.firstHourSelected) {
      this.notification.showSnack(
        this.translateService.instant('MSG_INSERT_PICKUP_TIME'),
        NotificationStyle.ERROR
      );
      return false;
    }
    if (!this.secondHourSelected) {
      this.notification.showSnack(
        this.translateService.instant('MSG_INSERT_RETURN_TIME'),
        NotificationStyle.ERROR
      );
      return false;
    }
    if (!DateUtil.isDateValid(this.firstDateSelected)) {
      this.notification.showSnack(
        this.translateService.instant('MSG_INVALID_PICKUP_DATE'),
        NotificationStyle.ERROR
      );
      return false;
    }
    if (!DateUtil.isDateValid(this.secondDateSelected)) {
      this.notification.showSnack(
        this.translateService.instant('MSG_INVALID_RETURN_DATE'),
        NotificationStyle.ERROR
      );
      return false;
    }
    // if (!DateUtil.isHourValid(this.firstHourSelected)) {
    //   this.notification.showSnack(this.translateService.instant('MSG_INVALID_PICKUP_TIME'), NotificationStyle.ERROR);
    //   return false;
    // }
    // if (!DateUtil.isHourValid(this.secondHourSelected)) {
    //   this.notification.showSnack(this.translateService.instant('MSG_INVALID_RETURN_TIME'), NotificationStyle.ERROR);
    //   return false;
    // }

    return true;
  }

  submitForm() {
    if (!this.validHoursAndDates()) return;
    if (this.validateFields())
      if (this.validateFirstRow() && this.validateSecondThirdRow())
        if (this.validateWhenSecondDateIsAfterFirstDate()) {
          this.reservaService.reservasData = {
            CodigoEmpresa: this.firstSelectedCity.CodigoEmpresa,
            CodigoUnidade: this.firstSelectedCity.CodigoUnidade,
            CodigoEmpresaDevolucao: this.secondSelectedCity.CodigoEmpresa,
            CodigoUnidadeDevolucao: this.secondSelectedCity.CodigoUnidade,
            CodigoCliente: this.reservaService?.reservasData?.CodigoCliente, // Campos inalterados
            CodigoGrupo: this.reservaService?.reservasData?.CodigoGrupo, // Campos inalterados
            CodigoProtecao: this.reservaService?.reservasData?.CodigoProtecao, // Campos inalterados
            CodigoTarifa: this.reservaService?.reservasData?.CodigoTarifa, // Campos inalterados
            DataInicio: this.firstDateSelected,
            DataTermino: this.secondDateSelected,
            HoraInicio: this.firstHourSelected,
            HoraTermino: this.secondHourSelected,
            PercDesconto: this.PercentDiscount,
            CodigoCupomDesconto: this.DiscountCouponCode,
            CodigoMunicipioRetirada: this.firstSelectedCity.CodigoMunicipio,
            CodigoMunicipioDevolucao: this.secondSelectedCity.CodigoMunicipio,
            Origem: this.reservaService?.reservasData?.Origem, // Campos inalterados
            ValorLocacaoJovem: this.reservaService?.reservasData?.ValorLocacaoJovem, // Campos inalterados
            PercDescontoTempo: this.reservaService?.reservasData?.PercDescontoTempo, // Campos inalterados
            ValorHoraExtra: this.reservaService?.reservasData?.ValorHoraExtra ?? 0,
            Adicionais: this.reservaService?.reservasData?.Adicionais, // Campos inalterados
          };
          this.reservaService.homeData = {
            firstSelectedCity: this.firstSelectedCity,
            secondSelectedCity: this.secondSelectedCity,
            firstDateSelected: this.firstDateSelected,
            secondDateSelected: this.secondDateSelected,
            firstHourSelected: this.firstHourSelected,
            secondHourSelected: this.secondHourSelected,
          };
          this.baseComponent.showToolbar = true;
          this.router.navigateByUrl(AppPages.RESERVATION);
        }
    this.getParametrosLocacao();
  }

  deliverAtSamePlace(event: any) {
    if (!this.firstSelectedCity) {
      return this.notification.showSnack(
        'Selecione uma cidade para retirada',
        NotificationStyle.ERROR
      );
    }
    this.deliverAtSamePlaceBool = event.checked;
    if (event?.checked) {
      this.myControlDevolucao.setValue(this.myControlRetirada.value);
      this.secondSelectedCity = this.firstSelectedCity;
      this.setSecondDayOpeningHours();
      return 0;
    } else {
      this.myControlDevolucao.setValue(null);
      this.secondSelectedCity = {} as Unidade;
      this.secondHoraInicioFuncionamento = '';
      this.secondHoraFinalFuncionamento = '';
      this.secondHourSelected = '';
      return 0;
    }
  }

  verifyDeliverAtSamePlace() {
    const devolucaoValue = this.myControlDevolucao.value;
    const retiradaValue = this.myControlRetirada.value;

    //verifica se o dado vem da api ou localstorage, e se os campos sao iguais
    if (
      devolucaoValue.length &&
      retiradaValue.length &&
      devolucaoValue === retiradaValue &&
      this.isDataFromApi
    ) {
      this.isSamePlaceDeliverDisabled = true;
    }
  }

  completeDevolucaoIfIsTheSamePlace() {
    const retiradaValue = this.myControlRetirada.value;

    if (this.isSamePlaceDeliverDisabled) {
      this.myControlDevolucao.setValue(retiradaValue);
      this.secondSelectedCity = this.firstSelectedCity;
    }
  }

  emptyCityRetirada(event: any) {
    const unidades = this.unidades;
    if (event?.target?.value?.length < 1) {
      this.firstSelectedCity = {} as Unidade;
      this.firstHoraInicioFuncionamento = '';
      this.firstHoraFinalFuncionamento = '';
      this.firstHourSelected = '';
    } else
      unidades.filter((i: Unidade) => {
        const cityName = i.Cidade + ' - ' + i.Estado;
        if (cityName?.toLowerCase() === event?.target?.value?.toLowerCase()) {
          this.firstSelectedCity = i;
          this.myControlRetirada.setValue(i.Cidade + ' - ' + i.Estado);
          this.setFirstDayOpeningHours();
        }
      });
    this.showSecondRow();
  }

  emptyCityDevolucao(event: any) {
    const unidades = this.unidades;
    if (event?.target?.value?.length == 0) {
      this.secondSelectedCity = {} as Unidade;
      this.secondHoraInicioFuncionamento = '';
      this.secondHoraFinalFuncionamento = '';
      this.secondHourSelected = '';
    } else
      unidades.filter((i: Unidade) => {
        const cityName = i.Cidade + ' - ' + i.Estado;
        if (cityName?.toLowerCase() === event?.target?.value?.toLowerCase()) {
          this.secondSelectedCity = i;
          this.myControlDevolucao.setValue(i.Cidade + ' - ' + i.Estado);
          this.setSecondDayOpeningHours();
          if (this.secondSelectedCity?.CodigoMunicipio == this.firstSelectedCity?.CodigoMunicipio)
            this.deliverAtSamePlaceBool = true;
          else this.deliverAtSamePlaceBool = false;
        }
      });
  }

  firstSelectCityEvent(unidade: Unidade) {
    this.firstSelectedCity = unidade;
    this.myControlRetirada.setValue(unidade.DescricaoUnidade);
    this.setFirstDayOpeningHours();
    this.showSecondRow();

    //verificando se local de retirada e devolucao ao chegarem
    //da api sao iguais, para poder habilitar essa funcao
    if (this.isSamePlaceDeliverDisabled) {
      this.completeDevolucaoIfIsTheSamePlace();
    }
  }

  secondSelectCityEvent(unidade: Unidade) {
    this.secondSelectedCity = unidade;
    this.myControlDevolucao.setValue(unidade.DescricaoUnidade);
    this.setSecondDayOpeningHours();
    if (
      this.secondSelectedCity?.CodigoMunicipio == this.firstSelectedCity?.CodigoMunicipio &&
      this.secondSelectedCity?.CodigoUnidade == this.firstSelectedCity?.CodigoUnidade
    )
      this.deliverAtSamePlaceBool = true;
    else this.deliverAtSamePlaceBool = false;
  }

  setFirstDate(data: any) {
    if (data?.targetElement?.value && data?.targetElement?.value?.length > 9) {
      this.firstDateSelected = data?.targetElement?.value;
    } else if (data?.target?.value && data?.target?.value?.length > 9) {
      this.firstDateSelected = data?.target?.value;
    }

    if (this.firstDateSelected) {
      this.setFirstDayOpeningHours();
      this.showSecondRow();
      this.firstMinDateDevolucao = new Date(DateUtil.changeDDMMtoMMDD(this.firstDateSelected));
    }
  }

  setSecondDate(data: any) {
    if (data?.targetElement?.value && data?.targetElement?.value?.length > 9)
      this.secondDateSelected = data?.targetElement?.value;
    else if (data?.target?.value && data?.target?.value?.length > 9)
      this.secondDateSelected = data?.target?.value;
    else this.secondDateSelected = '';
    if (this.secondDateSelected) this.setSecondDayOpeningHours();
    this.validateWhenSecondDateIsAfterFirstDate();
  }

  validateWhenSecondDateIsAfterFirstDate() {
    if (this.secondDateSelected?.length > 9) {
      let firstDate = this.firstDateSelected;
      let secondDate = this.secondDateSelected;
      const [day, month, year] = firstDate?.split('/');
      firstDate = [year, month, day]?.join('-');
      const [d, m, y] = secondDate?.split('/');
      secondDate = [y, m, d]?.join('-');

      if (this.firstHourSelected) firstDate = firstDate + 'T' + this.firstHourSelected;
      if (this.secondHourSelected) secondDate = secondDate + 'T' + this.secondHourSelected;

      var firstDateMilliseconds = new Date(firstDate).getTime();
      var secondDateMilliseconds = new Date(secondDate).getTime();

      if (!isNaN(firstDateMilliseconds) && !isNaN(secondDateMilliseconds))
        if (firstDateMilliseconds >= secondDateMilliseconds) {
          this.notification.showError(
            this.translateService.instant('MSG_INVALID_PICKUP_SECOND_DATE')
          );
          return false;
        }
    }
    return true;
  }

  setFirstHour(hora: any) {
    if (typeof hora == 'string' && hora?.length > 4) this.firstHourSelected = hora;
    else if (hora?.target?.value && hora?.target?.value?.length > 4)
      this.firstHourSelected = hora.target.value;
    this.showSecondRow();
  }

  setSecondHour(hora: any) {
    if (typeof hora == 'string' && hora?.length > 4) this.secondHourSelected = hora;
    else if (hora?.target?.value && hora?.target?.value?.length > 4)
      this.secondHourSelected = hora.target.value;
  }


  setFirstDayOpeningHours() {
    if (this.firstSelectedCity && this.firstDateSelected) {

      const addColonToHour = (hour: string) => {
        if (!hour || hour.length !== 4 || isNaN(+hour)) return hour; // retorna como está se for inválido
        return `${hour.slice(0, 2)}:${hour.slice(2, 4)}`;
      };

      this.firstDiaFechadoPorFeriado = false; // reset flag
      this.firstDiaNomeFeriado = ''; // reset nome do feriado

      const day = moment(this.firstDateSelected, 'DD/MM');
      const dayOfWeek = day.day();

      const findFeriado = this.firstSelectedCity.Feriados.find((feriado: Feriado) => {
        return feriado.Dia === day.date() && feriado.Mes === day.month() + 1;
      });

      if (dayOfWeek === 0) {
        this.firstHoraInicioFuncionamento = addColonToHour(this.firstSelectedCity.HoraInicioFuncionamentoDomingo);
        this.firstHoraFinalFuncionamento = addColonToHour(this.firstSelectedCity.HoraTerminoFuncionamentoDomingo);
      } else if (dayOfWeek === 6) {
        this.firstHoraInicioFuncionamento = addColonToHour(this.firstSelectedCity.HoraInicioFuncionamentoSabado);
        this.firstHoraFinalFuncionamento = addColonToHour(this.firstSelectedCity.HoraTerminoFuncionamentoSabado);
      } else if (findFeriado) {
        this.firstHoraInicioFuncionamento = addColonToHour(findFeriado.HoraInicio);
        this.firstHoraFinalFuncionamento = addColonToHour(findFeriado.HoraFim);

        // Se os horários do feriado indicam que está fechado
        if (!this.firstHoraInicioFuncionamento && !this.firstHoraFinalFuncionamento) {
          this.firstDiaFechadoPorFeriado = true;
          this.firstDiaNomeFeriado = findFeriado.Descricao || '';

        }
      } else {
        this.firstHoraInicioFuncionamento = addColonToHour(this.firstSelectedCity.HoraInicioFuncionamentoSegSex);
        this.firstHoraFinalFuncionamento = addColonToHour(this.firstSelectedCity.HoraTerminoFuncionamentoSegSex);
      }
    }
  }


  setSecondDayOpeningHours() {
    if (this.secondSelectedCity && this.secondDateSelected) {
      const addColonToHour = (hour: string) => {
        if (!hour || hour.length !== 4 || isNaN(+hour)) return hour; // retorna como está se for inválido
        return `${hour.slice(0, 2)}:${hour.slice(2, 4)}`;
      };
      this.secondDiaFechadoPorFeriado = false; // reset flag
      this.secondDiaNomeFeriado = ''; // reset nome do feriado

      const day = moment(this.secondDateSelected, 'DD/MM');
      const dayOfWeek = day.day(); // 0 = Domingo, 6 = Sábado

      const findFeriado = this.secondSelectedCity.Feriados.find((feriado: Feriado) => {
        return feriado.Dia === day.date() && feriado.Mes === day.month() + 1;
      });

      if (dayOfWeek === 0) {
        this.secondHoraInicioFuncionamento = addColonToHour(this.secondSelectedCity.HoraInicioFuncionamentoDomingo);
        this.secondHoraFinalFuncionamento = addColonToHour(this.secondSelectedCity.HoraTerminoFuncionamentoDomingo);
      } else if (dayOfWeek === 6) {
        this.secondHoraInicioFuncionamento = addColonToHour(this.secondSelectedCity.HoraInicioFuncionamentoSabado);
        this.secondHoraFinalFuncionamento = addColonToHour(this.secondSelectedCity.HoraTerminoFuncionamentoSabado);
      } else if (findFeriado) {
        this.secondHoraInicioFuncionamento = addColonToHour(findFeriado.HoraInicio);
        this.secondHoraFinalFuncionamento = addColonToHour(findFeriado.HoraFim);

        // Se estiver fechado o dia todo no feriado
        if (!this.secondHoraInicioFuncionamento && !this.secondHoraFinalFuncionamento) {
          this.secondDiaFechadoPorFeriado = true;
          this.secondDiaNomeFeriado = findFeriado.Descricao || '';
        }
      } else {
        this.secondHoraInicioFuncionamento = addColonToHour(this.secondSelectedCity.HoraInicioFuncionamentoSegSex);
        this.secondHoraFinalFuncionamento = addColonToHour(this.secondSelectedCity.HoraTerminoFuncionamentoSegSex);
      }
    }
  }

  add0ifLessThan10(value: any) {
    if (value < 10) return '0' + value;
    return value;
  }

  dateFilterRetiradaSundaySaturdayAndHolidays: DateFilterFn<Date | null> = (
    data: Date | null | any
  ) => {
    let blockSaturday = false;
    let blockSunday = false;
    let date: any;
    let month: any;
    let disableDateList: string[] = [];

    const diasAntecedencia = this.firstSelectedCity?.HorasAntecedenciaAberturaReservaWeb / 24;
    for (let index = 0; index < diasAntecedencia; index++) {
      const data = new Date();
      data.setDate(data.getDate() + index);
      const day = data?.getDate();
      const month = data?.getMonth() + 1;
      const year = data?.getFullYear();
      disableDateList.push(`${year}-${this.add0ifLessThan10(month)}-${this.add0ifLessThan10(day)}`);
    }

    this.firstSelectedCity?.Feriados.forEach((feriado: Feriado) => {
      if (feriado.Ano) {
        if (feriado.HoraInicio !== '0000' && feriado.HoraFim !== '0001') {
          return;
        }
        disableDateList.push(
          `${feriado.Ano}-${this.add0ifLessThan10(feriado.Mes)}-${this.add0ifLessThan10(
            feriado.Dia
          )}`
        );
      } else {
        this.years.forEach((year) => {
          if (feriado.HoraInicio) return;
          disableDateList.push(
            `${year}-${this.add0ifLessThan10(feriado.Mes)}-${this.add0ifLessThan10(feriado.Dia)}`
          );
        });
      }
    });

    if (data) data = data!._d;
    const day = data?.getDay();

    if (data?.getDate()?.toString()?.length! < 2) {
      date = '0' + data?.getDate().toString();
    } else {
      date = data?.getDate()?.toString();
    }

    if ((data?.getMonth()! + 1)?.toString()?.length < 2) {
      month = '0' + (data?.getMonth()! + 1).toString();
    } else {
      month = (data?.getMonth()! + 1)?.toString();
    }

    const currentDate = data?.getFullYear()?.toString() + '-' + month + '-' + date;

    if (!this.firstSelectedCity?.HoraInicioFuncionamentoDomingo && day == 0) blockSunday = true;
    if (!this.firstSelectedCity?.HoraInicioFuncionamentoSabado && day == 6) blockSaturday = true;

    if (disableDateList.includes(currentDate)) {
      return false;
    } else if (blockSaturday) {
      return day !== 6;
    } else if (blockSunday) {
      return day !== 0;
    } else {
      if (!this.firstDateOpen && !currentDate.includes('undefined')) {
        this.firstDateOpen = true;
        setTimeout(() => {
          this.firstDateDefault = new Date(data);
          this.firstDateSelected = moment(this.firstDateDefault).format('DD/MM/YYYY');
          this.setFirstDate(this.firstDateDefault);
        }, 100);
      }
      return true;
    }
  };

  dateFilterDevolucaoSundaySaturdayAndHolidays: DateFilterFn<Date | null> = (
    data: Date | null | any
  ) => {
    let blockSaturday = false;
    let blockSunday = false;
    let date: any;
    let month: any;
    let disableDateList: string[] = [];

    this.secondSelectedCity?.Feriados.forEach((feriado: Feriado) => {
      if (feriado.Ano) {
        if (feriado.HoraInicio !== '0000' && feriado.HoraFim !== '0001') {
          return;
        }
        disableDateList.push(
          `${feriado.Ano}-${this.add0ifLessThan10(feriado.Mes)}-${this.add0ifLessThan10(
            feriado.Dia
          )}`
        );
      } else {
        this.years.forEach((year) => {
          if (feriado.HoraInicio) return;
          disableDateList.push(
            `${year}-${this.add0ifLessThan10(feriado.Mes)}-${this.add0ifLessThan10(feriado.Dia)}`
          );
        });
      }
    });

    if (data) data = data!._d;
    const day = data?.getDay();

    if (data?.getDate()?.toString()?.length! < 2) {
      date = '0' + data?.getDate().toString();
    } else {
      date = data?.getDate()?.toString();
    }

    if ((data?.getMonth()! + 1)?.toString()?.length < 2) {
      month = '0' + (data?.getMonth()! + 1).toString();
    } else {
      month = (data?.getMonth()! + 1)?.toString();
    }

    const currentDate = data?.getFullYear()?.toString() + '-' + month + '-' + date;

    if (!this.firstSelectedCity?.HoraInicioFuncionamentoDomingo) blockSunday = true;
    if (!this.firstSelectedCity?.HoraInicioFuncionamentoSabado) blockSaturday = true;

    if (disableDateList.includes(currentDate)) {
      return false;
    } else if (blockSaturday && blockSunday) {
      return day !== 0 && day !== 6;
    } else if (blockSaturday) {
      return day !== 6;
    } else if (blockSunday) {
      return day !== 0;
    } else {
      return true;
    }
  };

  scrollTop() {
    let elmntToView = document.getElementById('top')!;
    elmntToView.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  changeLanguage(language: string) {
    if (language) this.i18nService.language = language?.toLowerCase();
  }

  changeCupomValue(event: any) {

    const value = event?.target?.value;
    if (value?.length > 4) this.getCupom(value)

    if (value?.length <= 4) {
      this.notification.showError(
        this.translateService.instant('MSG_COUPON_MIN_LENGTH')
      );
    }
    if (value?.length === 0) {
      this.cupom = null;
      this.reservaService.clearCupom();
    }
  }

  getCupom(value: string) {
    this.isLoading = true;
    this.controllerReserva
      .getCustomById('cupomDesconto', value)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (cupom: CupomEntity) => {
          this.cupom = cupom.Data[0];

          if (this.cupom.Ativo != 'N') {
            this.notification.showSnack(
              'Cupom de ' + cupom?.Data[0]?.Percentual + '% aplicado',
              NotificationStyle.SUCCESS
            );

            this.DiscountCouponCode = this.cupom.CodigoCupom;
            this.PercentDiscount = this.cupom.Percentual;
            this.reservaService.cupomData = this.cupom;
          } else {
            this.notification.showError(
              this.translateService.instant('MSG_COUPON_EXPIRED')
            );
          }
        },
        error: (err: any) => {
          this.requestError = true;
          this.reservaService.clearCupom();

          const mensagem = 'MSG_INVALID_COUPON';
          this.notification.showError(
            this.translateService.instant(mensagem)
          );
        },
      });
  }

  getParametrosLocacao() {
    this.isLoading = true;
    this.getParametrosLocacaoRepository.get().subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response) {
          const maximoHoraExtra = response?.Data?.find((param: any) => param.Parametro == "MaximoHorasExtras")
          const maximoHoraExtraCortesia = response?.Data?.find((param: any) => param.Parametro == "MaximoHorasExtrasCortesia")
          if (maximoHoraExtra) {
            sessionStorage.setItem('maximoHoraExtra', maximoHoraExtra?.Valor);
          } else {
            sessionStorage.setItem('maximoHoraExtra', '0');
          }
          if (maximoHoraExtraCortesia) {
            sessionStorage.setItem('maximoHoraExtraCortesia', maximoHoraExtraCortesia?.Valor);
          } else {
            sessionStorage.setItem('maximoHoraExtraCortesia', '0');
          }
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Erro ao obter parâmetros de locação:', error);
      }
    });
  }

  getConfiguracoesInternacionalizacao() {
    this.isLoading = true
    this.getConfiguracoesInternacionalizacaoRepository.get().subscribe({
      next: (response) => {
        if (response) {
          sessionStorage.setItem('customCurrencyDefault', response.Data.DefaultCurrencyLanguage)
          if (response.Data.PadraoMascaraCep) {
            sessionStorage.setItem('padraoMascaraCep', response.Data.PadraoMascaraCep)
          } else {
            sessionStorage.removeItem('padraoMascaraCep')
          }
          sessionStorage.setItem('desobrigarIdentificadorPessoa', response.Data.DesobrigarIdentificadorPessoa)
        }
      },
      error: (error) => {
        this.isLoading = false;
      }
    })
  }
}
